export class PrismHRAPIPermissionsResponse{
    public success:boolean = false;
    public errorCode?:string;
    public message?:string;
    public canCreatePEOSession:boolean = false;
    public allowedIPs:string[] = [];
    public permittedMethods:PermittedMethod[] = [];

    get displayMessage(){
        if(this.message) return this.message;
        else {
            if(this.errorCode=='NotFound') return "Verify your url."
            else return '';
        }
    }

    get sortedPermittedMethods(){
        return this.permittedMethods.sort((a,b)=>a.service.localeCompare(b.service))
    }
}

export class PermittedMethod{
    public service!:string;
    public options?:string[];
    public fromTime?:string;
    public toTime?:string;
}